module.exports = __webpack_public_path__ + "media/images/icons/icon_search_dark_grey-e86cad6bbe181cda3b9c2bda776ab46d.svg";